import {
  CONFIRM_SELECTED_RESULT,
  CONFIRM_SELECTED_HOTEL,
} from '../helpers/constants/actionsConstants';

import type {
  ConfirmSelectedResultAction,
  ConfirmSelectedHotelAction,
} from './types';

const confirmSelectedResult = (
  outboundDate: Date,
  inboundDate: Date | null,
  preferDirects: boolean,
  departureTimeRange?: string,
): ConfirmSelectedResultAction => ({
  type: CONFIRM_SELECTED_RESULT,
  payload: {
    outboundDate,
    inboundDate,
    preferDirects,
    departureTimeRange,
  },
  meta: {
    googleAnalyticsLogEvent: CONFIRM_SELECTED_RESULT,
  },
});

const hotelSelectedResult = (
  checkinDate: Date,
  checkoutDate: Date,
  destinationId: string,
  impressionId?: string,
): ConfirmSelectedHotelAction => ({
  type: CONFIRM_SELECTED_HOTEL,
  payload: {
    checkinDate,
    checkoutDate,
    destinationId,
    impressionId,
  },
  meta: {
    googleAnalyticsLogEvent: CONFIRM_SELECTED_HOTEL,
  },
});

export { confirmSelectedResult, hotelSelectedResult };
